import React from 'react';
import {useNavigate} from 'react-router';
import {RsnButton, RsnDialog} from '~/library/ui-kit';

export function AddressDialog() {
    const {onClose} = RsnDialog.useControls();
    const navigate = useNavigate();

    const handleVerifyClick = () => {
        navigate('/address-verification');
    };

    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader
                text='Address verification required'
                icon={{element: <RsnDialog.StatusIcon status={'alert'} />}}
            />
            <RsnDialog.Body>To use EU bank transfers, verify your address or choose another method.</RsnDialog.Body>
            <RsnDialog.Footer column>
                <RsnButton.Primary onClick={handleVerifyClick}>Verify address</RsnButton.Primary>
                <RsnButton.Secondary type='button' onClick={onClose}>
                    I got it
                </RsnButton.Secondary>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
